import SlackService from 'services/slack';

import actionTypes from '../constants';

export const unlinkSlackAccount = () => async dispatch => SlackService.unlinkSlackAccount()
  .then(() => {
    dispatch({ type: actionTypes.UNLINK_SLACK_ACCOUNT });
  });
